import gql from "graphql-tag";

const LANDING_PAGE_QUERY = gql`
    query{
        landingPage{
            slogan
            featured_blogs{
                id,
                title
                createdAt
                description
                preview{
                    url
                    formats
                }
            }
            Highlight_Section{
                title
                description
                link
            }
            featured_product_reviews{
                id,
                name,
                review
                image{
                    url
                    formats
                }
            }
        }
    }
`;

export default LANDING_PAGE_QUERY 